export interface IEntrada {
  id_entrada: string;
  idEntrada?: string;
  id_categorizacion: string;
  id_tema: null;
  indice: null;
  nombreEntrada: string;
  nombreEntradaCompleto: string;
  banConSeguimiento: number;
  justificacionSeguimiento: string;
  banEsActivo: number;
  id_empresa: string;
  desc_empresa: string;
  fecha_inicio: Date;
  remitente_descripcion: string;
  remitenteCompleto: string;
  idSobre: string;
  documentoSoporte: string;
  archivos?: any[];
  entregables?: any[];
}

export interface INuevaEntrada {
  id_entrada?: string;
  idEntrada: string;
  idCategorizacion: string;
  idTema: string;
  indiceEntrada: number;
  nombreEntrada: string;
  tieneSeguimiento: number;
  esActivo: number;
  remitente_descripcion: string;
  fecha_inicio: string;
  documentoSoporte: string;
  esDocumentoSoporte: boolean;
  archivos: any[];
  nombreEntradaCompleto: string;
  entregables: any[];
  nuevo?: boolean;
  nombre_empresa?:string
}

export interface IArchivoAcuerdo {
  id_entrada: string;
  indice: number;
  nombre_archivo: string;
  metadata: string;
  banEsActivo: number;
  ts_alta_audit: string;
  ts_actualiza_audit: string;
  usuario_audit: null;
  indiceEnTema: number;
  url: string;
}

export interface IEntregableAcuerdo {
  idEntregable: string;
  idEntrada: string;
  edoEntregable: number;
  nombreEntregable: string;
  urlEntregable: string;
  indice: number;
}

export interface IEntradas {
  entradas: IEntrada[];
}

export const IEntradasInitState: IEntradas = {
  entradas: [],
};

export interface IEntradaRequest {
  id_categorizacion: string;
  id_tipo_forma: number;
  id_empresa?: string;
}

export interface ITemasUser {
  notificacion: boolean;
  permiso: number;
  id?: string;
}
